import { useEffect, useMemo, useRef, useState } from 'react'
import type { ExtractionStage } from '../../../api/listeners/document-extraction'
import { Button } from '../../ui/button'
import { recognizedBirthDates } from './recognized-birthdate'
import css from './ui.recognition.module.scss'

type Props = {
    stage: ExtractionStage | null
    birthDate: string
    onBirthDate: (value: string, expectedBirthDate: string) => boolean
}

export const RecognizedBirthDate = ({ stage, birthDate, onBirthDate }: Props) => {
    const baseline = useRef(birthDate)
    const apply = useRef(onBirthDate)
    apply.current = onBirthDate
    const { dates, needsReview } = useMemo(() => recognizedBirthDates(stage), [stage])
    const [selected, setSelected] = useState<number | null>(null)
    const [state, setState] = useState<{ applied: boolean; message: string; date?: string }>({ applied: false, message: '' })
    const attempted = useRef('')
    const index = selected ?? (dates.length === 1 && !needsReview ? 0 : null)
    const date = index === null ? undefined : dates[index]

    useEffect(() => {
        if (!date) return
        const key = JSON.stringify([stage?.stageID, date])
        if (attempted.current === key) return
        attempted.current = key
        if (!apply.current(date, baseline.current)) {
            setState({ applied: false, message: 'Дата рождения не перенесена: анкета или дата уже изменены. Проверьте поле в «Основных данных».' })
            return
        }
        setState({ applied: true, message: 'Дата рождения перенесена в «Основные данные» и сохранится вместе с анкетой.', date })
    }, [date, stage?.stageID])

    if (!dates.length && !needsReview) return null
    return <section className={css.group} aria-label="Перенос даты рождения">
        <h5>Дата рождения</h5>
        {index === null ? <>
            <p className={css.warning}>{dates.length
                ? 'В паспортах разные даты рождения или есть неоднозначный результат. Выберите дату после проверки оригинала.'
                : 'Дата рождения требует проверки. Уточните полную дату по оригиналу.'}</p>
            {dates.map((value, itemIndex) => <p key={value}><Button onClick={() => setSelected(itemIndex)}>Перенести дату: {value}</Button></p>)}
        </> : <>
            <p role="status" aria-live="polite" className={state.applied ? undefined : css.warning}>{state.message}</p>
            {state.date && <p>{state.date}</p>}
        </>}
    </section>
}
